import { RootState } from '@/app/globalRedux/store'
import useLoginRouter from '@/app/hooks/useLoginRouter'
import { useTranslation } from '@/app/i18n/client'
import { Subscription } from '@/app/types/offersType'
import { Button } from '@/components/ui/button'
import Image from 'next/image'
import React from 'react'
import { useSelector } from 'react-redux'

const BuyersAlertBlocker: React.FC<Subscription> = ({
  name,
  limit,
  isBeneficiary,
}) => {
  const { t } = useTranslation()
  const loggedIn = useSelector((state: RootState) => state?.user?.loggedIn)
  const plan = useSelector((state: RootState) => state.user.userSubscription)
  const navigateToLogin = useLoginRouter()
  return (
    <div className="flex flex-col justify-center items-center gap-4 w-full">
      <div className="flex flex-row items-center gap-2">
        <Image
          height={17.5}
          width={18.9}
          alt="Warning-Icon"
          src={'/assets/Icons/WarningIcon.svg'}
        />
        <div className="text-[20px] text-[#222222] font-bold">
          {t('Access restricted')}!
        </div>
      </div>

      {/* Access Message */}
      <div className="flex flex-col gap-2 items-center justify-center">
        {loggedIn && plan !== 'Platinum' && plan !== 'Gold' && (
          <p className="text-[14px] text-[#6f6f6f] text-center px-6 flex flex-col space-y-2">
            {`${t(`Contact details are not accessible with your current plan`)}.`}
            <br />
            {`${t(`This feature is not available for Free and Silver members`)}.`}
            <br />
            <span className="font-bold text-[#222222]">
              {`${t('Upgrade to Gold or Platinum to unlock full access')}!`}
            </span>
          </p>
        )}

        {/* Sponsored Product Restriction */}
        {loggedIn && !(plan !== 'Platinum' && plan !== 'Gold') && (
          <p className="text-[14px] text-[#6f6f6f] text-center px-6">
            {t(
              'The contact details are not accessible since it is not a sponsored product.'
            )}
          </p>
        )}

        <div className="flex flex-row">
          {!loggedIn ? (
            <p className="text-[14px] text-[#222222] ml-1 gap-[1px] font-bold">
              {t('Login to access this feature')}
            </p>
          ) : (
            <div className="flex flex-col items-center gap-2 ">
              <div className="flex ">
                <p className="text-[14px] text-[#6f6f6f]">{`${t('Your current plan')} :`}</p>
                <p className="text-[14px] text-[#222222] ml-1 gap-[1px] font-bold">
                  {limit == '-1'
                    ? `${t(name)}`
                    : `${limit} ${t('profiles/week')}`}
                </p>
              </div>
              {/* There is no beneficiary Concept for Silver and Free subscription */}
              {!['Silver', 'Free'].includes(plan) && !isBeneficiary && (
                <p className="text-[14px] text-[#ff6b6b] ml-1 gap-[1px] font-bold">
                  {t('You must be a beneficiary to access this content')}
                </p>
              )}
            </div>
          )}
        </div>
      </div>

      {/* Buttons */}
      {name === 'Logged out' ? (
        <Button
          variant="secondary"
          size="sx"
          onClick={() => {
            navigateToLogin('login')
          }}
        >
          {t('LOGIN')}
        </Button>
      ) : plan !== 'Platinum' ? (
        <Button
          variant="secondary"
          size="sx"
          className="mt-4 py-3 text-[14px] font-bold"
        >
          <a href={'/solutions/for_buyers'}>{t('UPGRADE')}</a>
        </Button>
      ) : null}
    </div>
  )
}
export default BuyersAlertBlocker
